"use client";

import { FormProvider, useWvcForm } from "@/integrations/forms/FormProvider";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Form, FormField, FormItem, FormLabel, FormControl, FormMessage, FormDescription } from "@/components/ui/form";
import { Card, CardContent } from "@/components/ui/card";
import { Loader, MapPin, Phone, Mail, Clock } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function ReservasYUbicacion() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.15
  });
  return <section id="reservas-y-ubicación" ref={ref} className="relative py-20 px-4 sm:px-6 lg:px-8 overflow-hidden bg-background">
      {}
      <div className="absolute inset-0 opacity-[0.05] pointer-events-none" style={{
      backgroundImage: "url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1547753/img/mexican_tile_pattern_decorative.png)",
      backgroundSize: "400px 400px",
      backgroundRepeat: "repeat"
    }} />

      <div className="relative max-w-7xl mx-auto">
        {}
        <div className={`text-center mb-12 transition-all duration-[var(--duration-medium)] ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}`}>
          <h2 className="text-4xl md:text-5xl font-display font-bold text-foreground mb-4">
            Reservas y Ubicación
          </h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
            Asegura tu mesa en Marea Mezcal. Estamos ubicados frente al mar en
            el corazón de Playa del Carmen.
          </p>
        </div>

        {}
        <div className="grid lg:grid-cols-2 gap-8 items-start">
          {}
          <div className={`transition-all duration-[var(--duration-medium)] delay-100 ${isVisible ? "opacity-100 translate-x-0" : "opacity-0 -translate-x-5"}`}>
            <Card className="shadow-medium border border-border">
              <CardContent className="p-8">
                <h3 className="text-2xl font-display font-bold text-foreground mb-6">
                  Reserva de Mesa
                </h3>
                <FormProvider formId="reservation_form_home" sectionName="reservas-y-ubicación" defaultValues={{
                nombre: "",
                email: "",
                telefono: "",
                fecha: "",
                hora: "",
                personas: 2,
                comentarios: ""
              }} validationRules={{
                nombre: {
                  required: true,
                  minLength: 2,
                  maxLength: 50
                },
                email: {
                  required: true,
                  pattern: "email"
                },
                telefono: {
                  required: true,
                  pattern: "phone"
                },
                fecha: {
                  required: true
                },
                hora: {
                  required: true
                },
                personas: {
                  required: true,
                  min: 1,
                  max: 20
                }
              }} submitText="Reservar Mesa Ahora" successMessage="¡Tu reserva ha sido confirmada! Te enviaremos un correo de confirmación pronto." errorMessage="Hubo un problema al procesar tu reserva. Por favor, intenta nuevamente o contáctanos directamente.">
                  <ReservationForm />
                </FormProvider>
              </CardContent>
            </Card>
          </div>

          {}
          <div className={`space-y-6 transition-all duration-[var(--duration-medium)] delay-200 ${isVisible ? "opacity-100 translate-x-0" : "opacity-0 translate-x-5"}`}>
            {}
            <Card className="shadow-medium border border-border overflow-hidden">
              <div className="relative h-80 w-full">
                <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d14881.842426847936!2d-87.0814!3d20.6296!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8f4e433d95c28e55%3A0x5a2e4e8b4f5c6d7e!2sPlaya%20del%20Carmen%2C%20Quintana%20Roo%2C%20M%C3%A9xico!5e0!3m2!1ses!2smx!4v1234567890123!5m2!1ses!2smx" width="100%" height="100%" style={{
                border: 0,
                filter: "hue-rotate(10deg) saturate(0.85) brightness(0.95)"
              }} allowFullScreen loading="lazy" referrerPolicy="no-referrer-when-downgrade" title="Mapa de Marea Mezcal" className="absolute inset-0" />
              </div>
            </Card>

            {}
            <Card className="shadow-medium border border-border">
              <CardContent className="p-6 space-y-4">
                <h3 className="text-xl font-display font-bold text-foreground mb-4">
                  Información de Contacto
                </h3>

                <div className="flex items-start gap-3">
                  <MapPin className="size-5 text-primary mt-0.5 shrink-0" />
                  <div>
                    <p className="font-semibold text-foreground">Dirección</p>
                    <p className="text-muted-foreground text-sm">
                      Playa del Carmen, Quintana Roo, México
                    </p>
                  </div>
                </div>

                <div className="flex items-start gap-3">
                  <Phone className="size-5 text-primary mt-0.5 shrink-0" />
                  <div>
                    <p className="font-semibold text-foreground">Teléfono</p>
                    <p className="text-muted-foreground text-sm">
                      +52 984 123 4567
                    </p>
                  </div>
                </div>

                <div className="flex items-start gap-3">
                  <Mail className="size-5 text-primary mt-0.5 shrink-0" />
                  <div>
                    <p className="font-semibold text-foreground">Email</p>
                    <p className="text-muted-foreground text-sm">
                      reservaciones@mareamezcal.com
                    </p>
                  </div>
                </div>

                <div className="flex items-start gap-3">
                  <Clock className="size-5 text-primary mt-0.5 shrink-0" />
                  <div>
                    <p className="font-semibold text-foreground">Horario</p>
                    <p className="text-muted-foreground text-sm">
                      Lunes a Domingo: 18:00 - 00:00
                    </p>
                  </div>
                </div>
              </CardContent>
            </Card>
          </div>
        </div>
      </div>
    </section>;
}
function ReservationForm() {
  const {
    isSubmitting,
    isSubmitted,
    submitError,
    successMessage,
    handleSubmit,
    resetForm,
    control
  } = useWvcForm();
  if (isSubmitted && !submitError) {
    return <div className="p-6 bg-primary-light border border-primary/20 rounded-lg text-center">
        <p className="text-primary-dark font-medium mb-4">{successMessage}</p>
        <Button onClick={resetForm} variant="outline" className="border-primary text-primary hover:bg-primary/10">
          Hacer Otra Reserva
        </Button>
      </div>;
  }
  return <Form onSubmit={handleSubmit}>
      <div className="space-y-5">
        <FormField control={control} name="nombre" rules={{
        required: "El nombre completo es obligatorio",
        minLength: {
          value: 2,
          message: "El nombre debe tener al menos 2 caracteres"
        },
        maxLength: {
          value: 50,
          message: "El nombre no puede superar los 50 caracteres"
        }
      }} render={({
        field
      }) => <FormItem>
              <FormLabel>Nombre Completo</FormLabel>
              <FormControl>
                <Input placeholder="Juan Pérez" className="bg-background border-border focus-ring" {...field} />
              </FormControl>
              <FormDescription className="text-xs">
                Escribe tu nombre tal como aparece en tu identificación.
              </FormDescription>
              <FormMessage />
            </FormItem>} />

        <div className="grid sm:grid-cols-2 gap-5">
          <FormField control={control} name="email" rules={{
          required: "El correo electrónico es obligatorio",
          pattern: {
            value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
            message: "Ingresa un correo electrónico válido"
          }
        }} render={({
          field
        }) => <FormItem>
                <FormLabel>Correo Electrónico</FormLabel>
                <FormControl>
                  <Input type="email" placeholder="juan@example.com" className="bg-background border-border focus-ring" {...field} />
                </FormControl>
                <FormMessage />
              </FormItem>} />

          <FormField control={control} name="telefono" rules={{
          required: "El teléfono es obligatorio",
          pattern: {
            value: /^[+]?[\d\s()-]+$/,
            message: "Ingresa un número de teléfono válido"
          }
        }} render={({
          field
        }) => <FormItem>
                <FormLabel>Teléfono</FormLabel>
                <FormControl>
                  <Input type="tel" placeholder="+52 1 984 123 4567" className="bg-background border-border focus-ring" {...field} />
                </FormControl>
                <FormMessage />
              </FormItem>} />
        </div>

        <div className="grid sm:grid-cols-2 gap-5">
          <FormField control={control} name="fecha" rules={{
          required: "La fecha de reserva es obligatoria"
        }} render={({
          field
        }) => <FormItem>
                <FormLabel>Fecha de Reserva</FormLabel>
                <FormControl>
                  <Input type="date" className="bg-background border-border focus-ring" {...field} />
                </FormControl>
                <FormDescription className="text-xs">
                  Selecciona el día en que deseas reservar.
                </FormDescription>
                <FormMessage />
              </FormItem>} />

          <FormField control={control} name="hora" rules={{
          required: "La hora es obligatoria"
        }} render={({
          field
        }) => <FormItem>
                <FormLabel>Hora de Reserva</FormLabel>
                <FormControl>
                  <select className="flex h-9 w-full rounded-md border border-border bg-background px-3 py-2 text-sm focus-ring disabled:cursor-not-allowed disabled:opacity-50" {...field}>
                    <option value="">Selecciona una hora</option>
                    <option value="18:00">18:00</option>
                    <option value="18:30">18:30</option>
                    <option value="19:00">19:00</option>
                    <option value="19:30">19:30</option>
                    <option value="20:00">20:00</option>
                    <option value="20:30">20:30</option>
                    <option value="21:00">21:00</option>
                  </select>
                </FormControl>
                <FormMessage />
              </FormItem>} />
        </div>

        <FormField control={control} name="personas" rules={{
        required: "El número de personas es obligatorio",
        min: {
          value: 1,
          message: "Debe ser al menos 1 persona"
        },
        max: {
          value: 20,
          message: "Máximo 20 personas por reserva"
        }
      }} render={({
        field
      }) => <FormItem>
              <FormLabel>Número de Personas</FormLabel>
              <FormControl>
                <Input type="number" min="1" max="20" className="bg-background border-border focus-ring" {...field} onChange={e => field.onChange(Number(e.target.value))} />
              </FormControl>
              <FormMessage />
            </FormItem>} />

        <FormField control={control} name="comentarios" render={({
        field
      }) => <FormItem>
              <FormLabel>Observaciones / Solicitudes Especiales</FormLabel>
              <FormControl>
                <textarea rows={4} placeholder="Ej.: Mesa cerca de la ventana, alergias, etc." className="flex w-full rounded-md border border-border bg-background px-3 py-2 text-sm focus-ring disabled:cursor-not-allowed disabled:opacity-50 resize-none" {...field} />
              </FormControl>
              <FormMessage />
            </FormItem>} />

        {submitError && <div className="p-4 bg-red-50 border border-red-200 rounded-lg">
            <p className="text-red-800 text-sm">{submitError}</p>
          </div>}

        <Button type="submit" disabled={isSubmitting} className="w-full btn-primary h-12 text-base font-semibold">
          {isSubmitting ? <>
              <Loader className="animate-spin mr-2 size-5" />
              Procesando Reserva...
            </> : "Reservar Mesa Ahora"}
        </Button>
      </div>
    </Form>;
}